import React, {FC, ReactElement, useEffect, useState} from "react";
import {FieldArrayRenderProps} from "formik";
import {StatementDownloadIBANSettings} from "../../../model/statement/autofetch/StatementDownloadIBANSettings";
import {Button, FormControlLabel, Grid, MenuItem, Switch} from "@mui/material";
import TextFieldWithValidation from "../../../components/input/TextFieldWithValidation";
import {companyAccountsStore} from "../../../store/CompanyAccounts";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import {observer} from "mobx-react";
import {AlertColor} from "@mui/material/Alert/Alert";
import CurrencySelector from "../../../components/CurrencySelector";

export const AddIbanComponent: FC<{
    disableSettingsEdit: boolean,
    arrHelper: FieldArrayRenderProps,
    ibans: StatementDownloadIBANSettings[],
    showSnackBar: (messageType: AlertColor, messageText: string) => void
}> = observer((props): ReactElement => {
    const [iban, setIban] = useState<number | string>(0);
    const [currency, setCurrency] = useState<string>('EUR');
    const [automatic, setAutomatic] = useState(false);

    useEffect(() => {
        companyAccountsStore.refresh()
    }, []);

    const {arrHelper, disableSettingsEdit, ibans, showSnackBar} = props;
    return <>
        <Grid item container xs={12} spacing={2} alignItems="center">
            <Grid item>
                <TextFieldWithValidation
                        disabled={disableSettingsEdit}
                        select={true}
                        value={iban}
                        label="Iban"
                        fullWidth={true}
                        style={{minWidth: "20rem"}}
                        onChange={e => setIban(e.target.value)}
                >
                    <MenuItem value={0}>Select account</MenuItem>
                    {
                        companyAccountsStore.bankAccounts.map(account => {
                            return <MenuItem key={account.iban}
                                             value={account.iban}>{account.name} - {account.iban}</MenuItem>
                        })
                    }
                </TextFieldWithValidation>
            </Grid>
            <Grid item>
                <CurrencySelector
                        disabled={disableSettingsEdit}
                        fullWidth={true}
                        label="Currency"
                        onChange={code => setCurrency(code)}
                        value={currency}
                />
            </Grid>
            <Grid item>
                <FormControlLabel
                        control={
                            <Switch disabled={disableSettingsEdit} checked={automatic} color="primary"
                                    onChange={e => setAutomatic(e.target.checked)}/>
                        }
                        label={automatic ? "Run analysis automatically" : "Only download statement"}/>
            </Grid>
            <Grid item>
                <Button startIcon={<AddCircleOutlinedIcon/>} variant={"contained"} color="primary"
                        disabled={disableSettingsEdit}
                        onClick={() => {
                            if (!iban || !currency) {
                                showSnackBar("error", "Please select IBAN and currency")
                            } else {
                                const newItem: StatementDownloadIBANSettings = {
                                    iban: iban.toString(),
                                    currency: currency.toString(),
                                    analyzeAutomatically: automatic
                                }
                                if (ibans && ibans.find(it => it.iban === newItem.iban && it.currency === newItem.currency)) {
                                    showSnackBar("error", "This IBAN and currency pair already added")
                                } else {
                                    arrHelper.push(newItem)
                                    setIban(0);
                                    setCurrency("EUR");
                                    setAutomatic(false);
                                }
                            }
                        }}>Add</Button>
            </Grid>
        </Grid>
    </>;
});